import { useNavigate } from "react-router-dom";
import "./Navbar.css";
import logovanlight from "../../assets/Images/1logovanlight.png";

const Navbar = () => {
  const navigate = useNavigate();

  const scrollToFooter = () => {
    const footer = document.getElementById("site-footer");
    if (!footer) return;
    footer.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header className="nav">
      <div className="nav-logo" onClick={() => navigate("/")}>
        <img src={logovanlight} alt="logo" />
      </div>

      <nav className="nav-actions">
        {/* If you want to enable this later, it will be mobile friendly already */}
        {/* <button className="nav-button" onClick={scrollToFooter}>
          Contact me
        </button> */}
      </nav>
    </header>
  );
};

export default Navbar;
